import { render, staticRenderFns } from "./web-edit.vue?vue&type=template&id=a503abbc&"
import script from "./web-edit.vue?vue&type=script&lang=js&"
export * from "./web-edit.vue?vue&type=script&lang=js&"
import style0 from "./web-edit.vue?vue&type=style&index=0&id=a503abbc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports